import React from 'react';
import { Icon } from './Icon.js';
export const IconCryptoTrendUp = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M2.5 20L8 14.5L14 20.5L21.5 13", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M11 6L7.5 10H6.5L3 6L6.5 2H7.5L11 6Z", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" })));
};
//# sourceMappingURL=IconCryptoTrendUp.js.map